export interface Video {
  id: string;
  title: string;
  slug: string;
  thumbnail: string;
  duration: string;
  category: string;
  categorySlug: string;
  views: number;
  rating: number;
  description: string;
  tags: string[];
  publishDate: string;
  quality: string[];
}

export const featuredVideos: Video[] = [
  {
    id: 'v001',
    title: '探索深海奥秘：海洋深处未被发现的生物世界',
    slug: 'explore-deep-sea-mysteries',
    thumbnail: 'https://readdy.ai/api/search-image?query=Deep%20ocean%20mysterious%20marine%20life%20with%20bioluminescent%20creatures%20swimming%20in%20dark%20blue%20water%2C%20cinematic%20underwater%20documentary%20style%2C%20ethereal%20lighting%2C%20high%20quality%20nature%20photography&width=640&height=360&seq=mogu-video-feat-01&orientation=landscape',
    duration: '48:32',
    category: '纪录片',
    categorySlug: 'documentary',
    views: 1285000,
    rating: 9.4,
    description: '跟随深海探险队的脚步，深入人类尚未完全探索的海洋深处，发现那些奇特而神秘的深海生物。从发光的透明水母到巨型乌贼，每一个画面都震撼人心。',
    tags: ['海洋', '纪录片', '自然', '探索', '生物'],
    publishDate: '2026-08-01',
    quality: ['1080P', '4K'],
  },
  {
    id: 'v002',
    title: '五分钟学会Python数据分析：从入门到实战',
    slug: 'python-data-analysis-quick',
    thumbnail: 'https://readdy.ai/api/search-image?query=Modern%20programming%20workspace%20with%20laptop%20showing%20Python%20code%20and%20data%20charts%2C%20clean%20minimalist%20desk%20setup%2C%20warm%20ambient%20lighting%2C%20professional%20tech%20education%20style&width=640&height=360&seq=mogu-video-feat-02&orientation=landscape',
    duration: '05:18',
    category: '教育',
    categorySlug: 'education',
    views: 895000,
    rating: 9.2,
    description: '快速掌握Python数据分析的核心技巧！本教程涵盖Pandas、Matplotlib等主流库的基础使用，让你在短时间内能够独立完成数据分析任务。',
    tags: ['Python', '数据分析', '编程', '教程', '入门'],
    publishDate: '2026-08-05',
    quality: ['1080P', '4K'],
  },
  {
    id: 'v003',
    title: '全球最美徒步路线TOP10：此生必走的自然之旅',
    slug: 'top-10-hiking-trails',
    thumbnail: 'https://readdy.ai/api/search-image?query=Breathtaking%20mountain%20hiking%20trail%20with%20snow%20capped%20peaks%20and%20green%20valleys%2C%20warm%20golden%20sunset%20light%2C%20adventure%20travel%20photography%2C%20epic%20landscape%20view&width=640&height=360&seq=mogu-video-feat-03&orientation=landscape',
    duration: '32:15',
    category: '旅游',
    categorySlug: 'travel',
    views: 2150000,
    rating: 9.6,
    description: '从喜马拉雅山脚到巴塔哥尼亚高原，我们精选了全球最令人叹为观止的十条徒步路线，带你领略大自然的壮丽与神奇。',
    tags: ['徒步', '旅游', '自然', '户外', '冒险'],
    publishDate: '2026-07-28',
    quality: ['1080P', '4K', '8K'],
  },
  {
    id: 'v004',
    title: '经典电影回顾：《肖申克的救赎》深度解析',
    slug: 'shawshank-redemption-review',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20review%20scene%20with%20vintage%20movie%20projector%20and%20classic%20film%20posters%20on%20brick%20wall%2C%20warm%20nostalgic%20lighting%2C%20golden%20ratio%20composition%2C%20artistic%20cinema%20aesthetic&width=640&height=360&seq=mogu-video-feat-04&orientation=landscape',
    duration: '25:47',
    category: '影视',
    categorySlug: 'entertainment',
    views: 1680000,
    rating: 9.5,
    description: '深入剖析这部IMDb评分最高的电影之一，探讨希望、自由与人性的永恒主题。从叙事结构到镜头语言，带你重新认识这部不朽经典。',
    tags: ['电影', '解析', '经典', '影评', '肖申克的救赎'],
    publishDate: '2026-08-03',
    quality: ['1080P', '4K'],
  },
  {
    id: 'v005',
    title: '宇宙探索：NASA最新火星发现全解读',
    slug: 'nasa-mars-discoveries',
    thumbnail: 'https://readdy.ai/api/search-image?query=Martian%20landscape%20with%20NASA%20rover%20exploring%20red%20planet%20surface%2C%20stars%20in%20background%2C%20scientific%20exploration%20theme%2C%20stunning%20space%20photography%20with%20warm%20desert%20tones&width=640&height=360&seq=mogu-video-feat-05&orientation=landscape',
    duration: '36:20',
    category: '科技',
    categorySlug: 'technology',
    views: 3210000,
    rating: 9.7,
    description: 'NASA最新火星探测任务取得重大突破！本视频全面解读毅力号火星车的最新发现，包括远古微生物化石证据和火星地下水系统的全新认知。',
    tags: ['NASA', '火星', '宇宙', '科技', '探索'],
    publishDate: '2026-08-08',
    quality: ['1080P', '4K', '8K'],
  },
  {
    id: 'v006',
    title: '中华美食之旅：川菜的灵魂——辣椒与花椒的艺术',
    slug: 'sichuan-cuisine-art',
    thumbnail: 'https://readdy.ai/api/search-image?query=Authentic%20Sichuan%20cuisine%20cooking%20scene%20with%20red%20chili%20peppers%20and%20Sichuan%20peppercorns%20on%20wooden%20table%2C%20steaming%20hot%20dishes%2C%20warm%20rustic%20kitchen%20atmosphere%2C%20food%20photography&width=640&height=360&seq=mogu-video-feat-06&orientation=landscape',
    duration: '22:08',
    category: '美食',
    categorySlug: 'food',
    views: 1950000,
    rating: 9.3,
    description: '走进四川，探寻川菜的灵魂所在。从辣椒的选材到花椒的运用，从家常小炒到火锅盛宴，带你领略千年川菜文化的独特魅力。',
    tags: ['川菜', '美食', '烹饪', '中国文化', '辣椒'],
    publishDate: '2026-08-06',
    quality: ['1080P', '4K'],
  },
];

export const allVideos: Video[] = [
  ...featuredVideos,
  {
    id: 'v007',
    title: '人工智能简史：从图灵测试到ChatGPT',
    slug: 'ai-history-turing-to-chatgpt',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20AI%20concept%20art%20with%20neural%20network%20visualization%20and%20vintage%20computer%20evolution%2C%20warm%20technological%20aesthetic%2C%20clean%20minimal%20composition%2C%20knowledge%20education%20theme&width=640&height=360&seq=mogu-video-07&orientation=landscape',
    duration: '42:15',
    category: '科技',
    categorySlug: 'technology',
    views: 4560000,
    rating: 9.5,
    description: '从阿兰·图灵的经典论文到如今震撼世界的ChatGPT，人工智能经历了怎样的发展历程？本片为你完整梳理AI发展的每一个重要里程碑。',
    tags: ['AI', '人工智能', '科技', '历史', '深度学习'],
    publishDate: '2026-07-20',
    quality: ['1080P', '4K'],
  },
  {
    id: 'v008',
    title: '零基础瑜伽入门：30天变身瑜伽达人',
    slug: 'yoga-beginner-30-days',
    thumbnail: 'https://readdy.ai/api/search-image?query=Peaceful%20yoga%20studio%20with%20morning%20sunlight%20streaming%20through%20large%20windows%2C%20yoga%20mat%20on%20wooden%20floor%2C%20serene%20wellness%20atmosphere%2C%20warm%20natural%20tones&width=640&height=360&seq=mogu-video-08&orientation=landscape',
    duration: '18:45',
    category: '体育',
    categorySlug: 'sports',
    views: 789000,
    rating: 9.0,
    description: '完全零基础也不用担心！专业瑜伽教练手把手带你从最基本的呼吸法开始，循序渐进掌握各种瑜伽体式。',
    tags: ['瑜伽', '健身', '入门', '健康', '运动'],
    publishDate: '2026-08-02',
    quality: ['1080P'],
  },
  {
    id: 'v009',
    title: '中国古代建筑之美：故宫600年风云',
    slug: 'forbidden-city-600-years',
    thumbnail: 'https://readdy.ai/api/search-image?query=Forbidden%20City%20Beijing%20magnificent%20ancient%20Chinese%20architecture%20with%20golden%20roof%20and%20red%20walls%20under%20blue%20sky%2C%20imperial%20palace%20grandeur%2C%20cultural%20heritage%20photography&width=640&height=360&seq=mogu-video-09&orientation=landscape',
    duration: '55:30',
    category: '纪录片',
    categorySlug: 'documentary',
    views: 2890000,
    rating: 9.8,
    description: '故宫，这座世界上现存规模最大、保存最为完整的木质结构古建筑群，见证了中国600年的历史变迁。本片带你走进紫禁城的每一个角落。',
    tags: ['故宫', '建筑', '历史', '中国文化', '纪录片'],
    publishDate: '2026-07-15',
    quality: ['1080P', '4K', '8K'],
  },
  {
    id: 'v010',
    title: '吉他入门教程：10分钟学会弹唱《晴天》',
    slug: 'guitar-tutorial-sunny-day',
    thumbnail: 'https://readdy.ai/api/search-image?query=Acoustic%20guitar%20on%20wooden%20stand%20near%20sunlit%20window%2C%20music%20sheet%20and%20coffee%20cup%2C%20warm%20cozy%20home%20music%20room%2C%20artistic%20lifestyle%20photography&width=640&height=360&seq=mogu-video-10&orientation=landscape',
    duration: '10:22',
    category: '音乐',
    categorySlug: 'music',
    views: 1230000,
    rating: 9.1,
    description: '周杰伦经典歌曲《晴天》吉他弹唱教学，从和弦按法到节奏型详解，手把手教你弹奏这首无数人青春记忆中的旋律。',
    tags: ['吉他', '音乐', '教学', '周杰伦', '弹唱'],
    publishDate: '2026-08-04',
    quality: ['1080P', '4K'],
  },
  {
    id: 'v011',
    title: '世界顶级超跑盘点：速度与激情的极致演绎',
    slug: 'world-top-supercars',
    thumbnail: 'https://readdy.ai/api/search-image?query=Luxury%20red%20supercar%20on%20racing%20track%20at%20sunset%2C%20speed%20and%20motion%20blur%2C%20dramatic%20lighting%2C%20automotive%20excellence%20photography%2C%20warm%20golden%20hour%20tones&width=640&height=360&seq=mogu-video-11&orientation=landscape',
    duration: '28:40',
    category: '汽车',
    categorySlug: 'automotive',
    views: 1870000,
    rating: 9.2,
    description: '从法拉利到布加迪，盘点全球最顶级的超级跑车，感受每一台引擎轰鸣背后的匠心工艺与极致性能。',
    tags: ['超跑', '汽车', '法拉利', '布加迪', '速度'],
    publishDate: '2026-07-25',
    quality: ['1080P', '4K'],
  },
  {
    id: 'v012',
    title: '儿童科学小实验：在家就能做的20个趣味实验',
    slug: 'kids-science-experiments',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20science%20experiments%20on%20wooden%20table%20with%20test%20tubes%20and%20beakers%2C%20bright%20cheerful%20children%20education%20theme%2C%20warm%20natural%20light%2C%20fun%20learning%20atmosphere&width=640&height=360&seq=mogu-video-12&orientation=landscape',
    duration: '15:50',
    category: '教育',
    categorySlug: 'education',
    views: 567000,
    rating: 9.0,
    description: '专为小朋友们设计的趣味科学实验合集！用家里常见的材料就能做出令人惊叹的科学实验，激发孩子对科学的兴趣。',
    tags: ['科学', '儿童', '实验', '教育', '亲子'],
    publishDate: '2026-08-07',
    quality: ['1080P'],
  },
];